import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {
  AdminRoutesEnum,
  AdminUsersRoutes,
  RoutesEnum,
  UserProfileRoutes,
  UserUsersAndPaxRoutes,
} from 'src/app/core/enums/routes.enum';
import { ToastService } from 'src/app/core/services/toast.service';
import { MenuListLogicService } from 'src/app/core/services/menu-list-logic.service';
import { redirectAndBypassUnsavedDataCheck } from '../../functions/redirect-and-bypass-unsaved-data-check';

@Injectable({
  providedIn: 'root',
})
export class CompetenceUserService {
  constructor(
    private router: Router,
    private translateService: TranslateService,
    private toastService: ToastService,
    private menuListLogicService: MenuListLogicService
  ) {}

  routeToNewCompetence(userId: string, competenceId: string, competenceName = ''): void {
    this.toastService.error(
      `${this.translateService.instant('pleaseAddRequiredCompetenceWithName')} ${competenceName}`
    );

    const moduleName = this.router.url;
    let redirectUrl = '';
    if (moduleName.includes(RoutesEnum.Profile)) {
      redirectUrl = `${UserProfileRoutes.CompetenceUserRegister}${userId}/${competenceId}`;
    } else if (moduleName.includes(AdminRoutesEnum.Users)) {
      redirectUrl = `${AdminUsersRoutes.CompetenceUserRegister}${userId}/${competenceId}`;
    }

    redirectAndBypassUnsavedDataCheck(redirectUrl);
  }

  routeBackToUserCompetencesList(userId: string): void {
    const isInAdmin = this.menuListLogicService.isCurrentUrlInAdmin();
    if (isInAdmin) {
      redirectAndBypassUnsavedDataCheck(
        `${AdminUsersRoutes.Users}/${userId}/(detailsOut:competence)`
      );
    } else {
      const url = this.router.url.includes('profile')
        ? `${RoutesEnum.Profile}/view/(details:competence)`
        : `${UserUsersAndPaxRoutes.Users}/${userId}/(detailsOut:competence)`;
      redirectAndBypassUnsavedDataCheck(url);
    }
  }
}
